import { useEffect, useState } from 'react';

export const useIsKeyDown = (key: KeyboardEvent['key']) => {
  const [isKeyDown, setIsKeyDown] = useState(false);

  const onKey = (e: KeyboardEvent) => {
    if (e.key !== key) return;

    if (e.type === 'keydown') {
      setIsKeyDown(true);
    } else if (e.type === 'keyup') {
      setIsKeyDown(false);
    }
  };

  const onBlur = (e: FocusEvent) => {
    setIsKeyDown(false);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    window.addEventListener('keydown', onKey);
    window.addEventListener('keyup', onKey);
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('keyup', onKey);
      window.removeEventListener('blur', onBlur);
      setIsKeyDown(false);
    };
  }, [key]);

  return [isKeyDown, setIsKeyDown];
};
